export default __webpack_public_path__ + "static/media/assessment-explanation-wrong.75f1bc88.svg";